<h2 mat-dialog-title class="mat-dialog-title">Add Archive Job</h2>
<mat-dialog-content>
  <!--<div style="display: flex; flex-direction: column; gap: 10px;">-->
  <div class="mat-dialog-content">
    <div class="form-control-wrapper">
      <mat-form-field>
        <mat-label>Title</mat-label>
        <input matInput placeholder="Archive" cdkTextareaAutosize [(ngModel)]="title" />
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" (click)="ok()">Ok</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
